function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "surface1",
  transform: "translate(-0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M77.086,23.947,75.314,34.281a2.526,2.526,0,0,0,3.666,2.664l9.28-4.879,9.28,4.879a2.53,2.53,0,0,0,3.643-2.8l-1.749-10.2,7.508-7.318a2.528,2.528,0,0,0-1.4-4.311L95.167,10.81l-4.64-9.4a2.528,2.528,0,0,0-4.533,0l-4.64,9.4L70.979,12.318a2.528,2.528,0,0,0-1.4,4.311Zm0,0",
  transform: "translate(-56.806 0)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M129.281,277.64a9.258,9.258,0,1,0,9.258-9.257A9.269,9.269,0,0,0,129.281,277.64Zm0,0",
  transform: "translate(-107.084 -229.335)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  "data-name": "Path 76",
  d: "M61.368,301.945a3.56,3.56,0,0,0-5.035,0L40.025,318.253a2.527,2.527,0,0,1-1.787.74H24.673a2.524,2.524,0,0,1-1.787-.74L6.578,301.945a3.561,3.561,0,0,0-5.036,5.035L21.067,326.5a2.526,2.526,0,0,1,.74,1.787v8.177H41.1v-8.177a2.526,2.526,0,0,1,.74-1.787L61.368,306.98a3.559,3.559,0,0,0,0-5.035Zm0,0",
  transform: "translate(0 -259.448)",
  fill: "#707070"
}));

function SvgSurface(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.911,
    height: 77.02,
    viewBox: "0 0 61.911 77.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurface);
export default __webpack_public_path__ + "static/media/surface.f4b962eb.svg";
export { ForwardRef as ReactComponent };